import { render } from "./FutureMiners.vue?vue&type=template&id=9a66907e"
import script from "./FutureMiners.vue?vue&type=script&lang=js"
export * from "./FutureMiners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__